import calculateCurrentIndexes from "@/components/Kanban/KPI/calculateIndex";
const filterInitiativesByImpactActuals = (initiative, value, key) => {
  const { currentMonthIndex } = calculateCurrentIndexes();
  const isImpactCheck = key === 'Actual impact update check (for last completed and previous period)';
  const isKPICheck = key === 'Actual KPI update check (for last completed and previous period)';
  const dataSources = [];
  if (isImpactCheck && initiative.impact) dataSources.push(...initiative.impact);
  if (isKPICheck && initiative.KPI) dataSources.push(...initiative.KPI);

  const isValidPlanOrActual = (v) => v !== null && v !== undefined;

  const lastCompletedMonthIndex = currentMonthIndex - 1;
  const previousMonthsIndices = Array.from({ length: lastCompletedMonthIndex }, (_, i) => i);

  // --- Handle initiatives that are On Hold/Cancelled or low stage first ---
  if (
    ['L0', 'L1', 'L2'].includes(initiative.stage) ||
    ['On Hold', 'Cancelled', 'Rejected'].includes(initiative.weeklyStatus)
  ) {
    const filterValues = Array.isArray(value) ? value : [value];
    return filterValues.includes('No actuals (below L3 or cancelled/on hold)');
  }

  // --- Check for 'No actuals required or no impacts' ---
  const hasNoPlanUntilCurrentMonth = !dataSources.some(d => {
    if (!d || !d.monthlyPlan) return false;
    for (let i = 0; i <= currentMonthIndex; i++) {
      if (isValidPlanOrActual(d.monthlyPlan[i])) {
        return true;
      }
    }
    return false;
  });

  const hasNoImpactOrKPI = dataSources.length === 0;
  const hasFinancialImpact = initiative.hasFinancialImpact;

  if (hasNoPlanUntilCurrentMonth || hasNoImpactOrKPI || !hasFinancialImpact) {
    const filterValues = Array.isArray(value) ? value : [value];
    return filterValues.includes('No actuals required or no impacts');
  }

  // --- Aggregate statuses based on new logic ---
  const initiativeStatuses = new Set();

  // Track high-level status for the entire initiative
  let hasAnyMissingLastCompleted = false;
  let hasAnyMissingPrevious = false;
  let allImpactsFilledLastCompleted = true;
  let allImpactsFilledPrevious = true;

  dataSources.forEach(dataSource => {
    // Determine plan indices for previous and last completed months
    const previousMonthsWithPlan = previousMonthsIndices.filter(index => isValidPlanOrActual(dataSource?.monthlyPlan?.[index]));
    const lastCompletedMonthHasPlan = isValidPlanOrActual(dataSource?.monthlyPlan?.[lastCompletedMonthIndex]);

    // Check for missing actuals for this specific impact/KPI
    const hasMissingActualForLastCompleted = lastCompletedMonthHasPlan && !isValidPlanOrActual(dataSource?.monthlyActual?.[lastCompletedMonthIndex]);
    const hasMissingActualForPrevious = previousMonthsWithPlan.some(index => !isValidPlanOrActual(dataSource?.monthlyActual?.[index]));

    // Update the high-level flags for the entire initiative
    if (hasMissingActualForLastCompleted) {
      hasAnyMissingLastCompleted = true;
      allImpactsFilledLastCompleted = false;
    }
    if (hasMissingActualForPrevious) {
      hasAnyMissingPrevious = true;
      allImpactsFilledPrevious = false;
    }

    if (lastCompletedMonthHasPlan && !isValidPlanOrActual(dataSource?.monthlyActual?.[lastCompletedMonthIndex])) {
      allImpactsFilledLastCompleted = false;
    }
    if (previousMonthsWithPlan.length > 0 && previousMonthsWithPlan.some(index => !isValidPlanOrActual(dataSource?.monthlyActual?.[index]))) {
      allImpactsFilledPrevious = false;
    }

  });

  // Apply logic to populate the initiativeStatuses set
  if (hasAnyMissingLastCompleted && hasAnyMissingPrevious) {
    initiativeStatuses.add('Missing actual in last completed and previous completed months');
  } else if (hasAnyMissingLastCompleted) {
    initiativeStatuses.add('Missing actual in last completed month');
  } else if (hasAnyMissingPrevious) {
    initiativeStatuses.add('Missing actual in previous months');
  }

  if (allImpactsFilledLastCompleted && allImpactsFilledPrevious) {
    initiativeStatuses.add('Filled actual (last completed and previous months required)');
  } else if (allImpactsFilledLastCompleted) {
    initiativeStatuses.add('Filled actual (last completed month required only)');
  } else if (allImpactsFilledPrevious) {
    initiativeStatuses.add('Filled actual (previous months required only)');
  }

  const filterValues = Array.isArray(value) ? value : [value];
  return filterValues.some(filterValue => initiativeStatuses.has(filterValue));
};

export default filterInitiativesByImpactActuals;